import { render, staticRenderFns } from "./ConfirmPassword.vue?vue&type=template&id=5dcef9c0&scoped=true&"
import script from "./ConfirmPassword.vue?vue&type=script&lang=js&"
export * from "./ConfirmPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcef9c0",
  null
  
)

export default component.exports